// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PlusCircle40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PlusCircle40Filled: FC<PlusCircle40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M18.695 28.333h2.777V21.5h6.861v-2.778h-6.86v-7.055h-2.778v7.055h-7.028V21.5h7.028v6.833Zm1.313 8.334c-2.301 0-4.463-.438-6.487-1.313a16.905 16.905 0 0 1-5.299-3.576 16.899 16.899 0 0 1-3.576-5.301c-.875-2.025-1.313-4.189-1.313-6.49 0-2.303.438-4.467 1.313-6.492.875-2.024 2.067-3.787 3.576-5.287 1.51-1.5 3.277-2.687 5.301-3.562 2.025-.875 4.189-1.313 6.49-1.313 2.303 0 4.467.438 6.492 1.313 2.024.875 3.787 2.062 5.287 3.562s2.687 3.264 3.562 5.292 1.313 4.192 1.313 6.492c0 2.301-.438 4.463-1.313 6.487-.875 2.023-2.062 3.788-3.562 5.293-1.5 1.506-3.264 2.699-5.292 3.577-2.028.878-4.192 1.318-6.492 1.318Z" />
        </svg>
    );
};

export default PlusCircle40Filled;
